import * as React from "react";
import { TableFieldDataItem } from "../../table-field.types";
import { DatasheetFieldComponentOriginFieldGetDto } from "@common/dto/datasheet/field-component/origin-field-dto";

export type RowProps = {
  selected: boolean;
  columns: Array<DatasheetFieldComponentOriginFieldGetDto>;
  data: TableFieldDataItem;
  onClick: (data: TableFieldDataItem) => void;
};

export const useController = (props: RowProps) => {
  const { onClick, data } = props;

  const handleClick = React.useCallback(() => {
    onClick(data);
  }, [data, onClick]);

  return {
    handleClick,
  };
}